export default "/fonts/vendor/remixicon/remixicon.ttf?f2616f597cf98f38d2347c9648bfe049";